export const getURL = () => process.env.API_BASE_URL || process.env.NEXT_PUBLIC_API_BASE_URL || 'https://gingeredu.herokuapp.com/';
